import { render, staticRenderFns } from "./SpNav.vue?vue&type=template&id=2849072f&"
import script from "./SpNav.vue?vue&type=script&lang=js&"
export * from "./SpNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports